import Button from '@anm/components/buttons/Button';
import TemplateSlider from '@anm/components/templates/TemplatesSlider';
import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import { capitalizeWord } from '@anm/helpers/string/capitalize';
import { memo, FC } from 'react';

import routes from '../../../routes';

import { useSliderHandlers } from './hooks';
import { TemplateSliderProps } from './types';

const { Link } = routes;

const TemplatesSliderWrapper: FC<TemplateSliderProps> = ({
  title,
  ...otherProps
}) => {
  const [
    templates,
    canHideSlider,
    seeAllLinkParams,
    renderTemplate
  ] = useSliderHandlers(otherProps);

  if (canHideSlider || !templates) return null;

  return (
    <TemplateSlider
      title={capitalizeWord(title)}
      list={templates.list}
      isPending={!!templates?.isPending}
      renderItem={renderTemplate}
    >
      <Link route={VIDEO_TEMPLATE_ROUTE} params={seeAllLinkParams}>
        <a>
          <Button size="big" variant="silver-border">
            See all
          </Button>
        </a>
      </Link>
    </TemplateSlider>
  );
};

export default memo(TemplatesSliderWrapper);
